import {MenuItem} from "./MobileMenu/MenuTypes";
import NavDropdownItem from "./NavDropdownItem";
import NavElement from "./NavElement";
import useDynamicMenuItems from "./useDynamicMenuItems";
import useHoverMenus, {UseHoverMenus} from "./useHoverMenus";

export type HorizontalNavItemsProps = {
	items: MenuItem[];
	hoverHandlers?: UseHoverMenus;
	classes?: {
		root?: string;
	};
};

const HorizontalNavItems: React.FC<HorizontalNavItemsProps> = ({
	classes,
	items,
	hoverHandlers,
}) => {
	const defaultHoverHandlers = useHoverMenus();
	const {
		activeSubmenu,
		isSubmenuOpen,
		onNavItemMouseEnter,
		onNavItemMouseLeave,
		onDropdownItemMouseEnter,
		onDropdownItemMouseLeave,
	} = hoverHandlers ?? defaultHoverHandlers;

	const dynamicMenuItems = useDynamicMenuItems(items);

	return (
		<div className={classes?.root}>
			<div className="flex h-full flex-grow items-center justify-start gap-4">
				{dynamicMenuItems.map((item) => {
					if (item.menuItems) {
						return (
							<NavDropdownItem
								key={item.id}
								isOpen={activeSubmenu === item.id && isSubmenuOpen}
								onMouseEnter={onDropdownItemMouseEnter(item.id)}
								onMouseLeave={onDropdownItemMouseLeave}
								{...item}
							/>
						);
					}
					if (!("menuItems" in item)) {
						return (
							<NavElement
								key={item.id}
								href={item.href}
								onHoverStart={onNavItemMouseEnter}
								onHoverEnd={onNavItemMouseLeave}
							>
								{item.label}
							</NavElement>
						);
					}
				})}
			</div>
		</div>
	);
};

export default HorizontalNavItems;
